/**
 * `tenants/eviction-notices/` — Node-only feature, no Django counterpart.
 * See refactor/backend/src/modules/evictionNotices/routes.ts and
 * refactor/docs/PARITY_NOTES.md. No create function exists here — a notice
 * is never created through this API.
 */
import { apiClient } from '../client';
import { EVICTION_NOTICES } from './paths';
import type { Paginated } from '../types';
import type { EvictionNotice } from '../../types/evictionNotice';

export async function listEvictionNotices(params?: { page?: number }): Promise<Paginated<EvictionNotice>> {
  const response = await apiClient.get<Paginated<EvictionNotice>>(EVICTION_NOTICES, { params });
  return response.data;
}

export async function withdrawEvictionNotice(id: number): Promise<EvictionNotice> {
  const response = await apiClient.post<EvictionNotice>(`${EVICTION_NOTICES}${id}/withdraw/`);
  return response.data;
}
